export default __webpack_public_path__ + "static/media/software_engineer-black.6d6f2dc9.svg";